/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../../extendIcon';

const ExportCSV = props => (
  <svg
    viewBox="0 0 128 128"
    width="1em"
    height="1em"
    {...props}
    cursor="pointer"
  >
    <title>{props.title || 'PDF'}</title>
    <rect x="31.602" y="47.697" width="64.812" height="7.2" />
    <rect x="31.602" y="24.393" width="36.008" height="7.201" />
    <rect x="31.602" y="70.994" width="64.812" height="7.202" />
    <rect x="31.602" y="94.298" width="64.812" height="7.202" />
    <path
      d="M85.382,0H13.444v128h101.123V27.796L85.382,0z M87.687,12.803l13.44,12.801h-13.44V12.803z M21.124,120.318V7.684h58.883
		v25.599h26.876v87.036H21.124z"
    />
  </svg>
);

export default extendIcon(ExportCSV);
